module.exports = __webpack_public_path__ + "img/2023-23.fae7fced.jpg";